import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { alpha } from '@mui/material/styles';

// Register all required Chart.js components
Chart.register(...registerables, ChartDataLabels);

// Apply theme-driven defaults (call this whenever the theme changes)
export function applyChartTheme(theme) {
  Chart.defaults.font.family = theme.typography.fontFamily;
  Chart.defaults.color = theme.palette.text.secondary;
  Chart.defaults.borderColor = theme.palette.divider;
  Chart.defaults.maintainAspectRatio = false;
  Chart.defaults.plugins.legend.labels.color = theme.palette.text.secondary;
  Chart.defaults.plugins.title.color = theme.palette.text.primary;
  // Improve tooltip contrast and legibility
  const tooltipBg = theme.palette.mode === 'dark'
    ? alpha((theme.palette.grey && theme.palette.grey[900]) || '#121212', 0.92)
    : theme.palette.common.white;
  Chart.defaults.plugins.tooltip.backgroundColor = tooltipBg;
  Chart.defaults.plugins.tooltip.borderColor = theme.palette.divider;
  Chart.defaults.plugins.tooltip.borderWidth = 1;
  Chart.defaults.plugins.tooltip.displayColors = false;
  Chart.defaults.plugins.tooltip.titleColor = theme.palette.text.primary;
  Chart.defaults.plugins.tooltip.bodyColor = theme.palette.text.secondary;
  Chart.defaults.scale.grid.color = theme.palette.divider;
  Chart.defaults.plugins.datalabels = {
    color: theme.palette.text.primary,
    font: { weight: 'bold' },
    formatter: (value) => value,
    // key changes: allow drawing beyond element, but clamp to chartArea and add small offset
    clip: false,
    clamp: true,
    anchor: 'end',
    align: 'end',
    offset: 4,
  };

  // Always leave headroom for data labels on linear axes
  Chart.defaults.scales.linear = {
    ...Chart.defaults.scales.linear,
    // Add ~10% extra range above (and below if needed) your data
    grace: '10%',
  };

  // A little top padding so labels never hug the canvas edge
  Chart.defaults.layout = Chart.defaults.layout || {};
  Chart.defaults.layout.padding = {
    ...(Chart.defaults.layout.padding || {}),
    top: 8,
  };
}

// Helper to create gradient fills
export function createVerticalGradient(ctx, area, color, alpha = 0.2) {
  const gradient = ctx.createLinearGradient(0, area.top, 0, area.bottom);
  gradient.addColorStop(0, `${color}33`); // approx 0.2 alpha if color is hex; fallback handled below
  gradient.addColorStop(1, `${color}00`);
  return gradient;
}

export default Chart; 